/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DashboardAliases {
  BODY_CENTER_CARD_CONTAINER_ZONE = 'body-center-card-container-zone',
  BODY_CENTER_CARD_CONTAINER_ZONE_DECK_01 = 'body-center-card-container-zone-deck-01',
  BODY_CENTER_CARD_CONTAINER_ZONE_DECK_02 = 'body-center-card-container-zone-deck-02',
  CARD_CONTACTS = 'card-contacts',
  CARD_CONTACTS_MOBILE = 'card-contacts-mobile',
  CARD_CONTAINER_BODY_0 = 'card-container-body-0',
  CARD_CONTAINER_BODY_0_DECK_01 = 'card-container-body-0-deck-01',
  CARD_CONTAINER_BODY_0_DECK_02 = 'card-container-body-0-deck-02',
  CARD_CONTAINER_FOOTER_0 = 'card-container-footer-0',
  CARD_CONTAINER_FOOTER_0_DECK_01 = 'card-container-footer-0-deck-01',
  CARD_CONTAINER_FOOTER_0_DECK_02 = 'card-container-footer-0-deck-02',
  CARD_CONTAINER_HEADER_ZONE_0 = 'card-container-header-zone-0',
  CARD_CONTAINER_HEADER_ZONE_1 = 'card-container-header-zone-1',
  CARD_CONTAINER_HEADER_ZONE_01_DECK_01 = 'card-container-header-zone-01-deck-01',
  CARD_CONTAINER_HEADER_ZONE_01_DECK_02 = 'card-container-header-zone-01-deck-02',
  CARD_CONTAINER_HEADER_ZONE_11_DECK_01 = 'card-container-header-zone-11-deck-01',
  CARD_CONTAINER_HEADER_ZONE_11_DECK_02 = 'card-container-header-zone-11-deck-02',
  CARD_CONTAINER_SEPARATOR_0 = 'card-container-separator-0',
  CARD_CONTAINER_SEPARATOR_0_DECK_01 = 'card-container-separator-0-deck-01',
  CARD_CONTAINER_SEPARATOR_0_DECK_02 = 'card-container-separator-0-deck-02',
  CARD_CONTAINER_SEPARATOR_2 = 'card-container-separator-2',
  CARD_CONTAINER_SEPARATOR_2_DECK_01 = 'card-container-separator-2-deck-01',
  CARD_CONTAINER_SEPARATOR_2_DECK_02 = 'card-container-separator-2-deck-02',
  CARD_MAINTENANCE = 'card-maintenance',
  CARD_MESSAGES = 'card-messages',
  CARD_MESSAGES_MOBILE = 'card-messages-mobile',
  CARD_MESSAGES_TMP = 'card-messages-tmp',
  CONTACT_CARD = 'contact-card',
  CONTACT_CARD_MOBILE = 'contact-card-mobile',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  DECK_01 = 'deck-01',
  DECK_02 = 'deck-02',
  DECK_CONTACTS = 'deck-contacts',
  DECK_CONTACTS_MOBILE = 'deck-contacts-mobile',
  DECK_MESSAGES = 'deck-messages',
  DECK_MESSAGES_MOBILE = 'deck-messages-mobile',
  DECK_MESSAGES_TMP = 'deck-messages-tmp',
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  FETCH_2 = 'fetch-2',
  FETCH_CONTACTS = 'fetch-contacts',
  FETCH_CONTACTS_MOBILE = 'fetch-contacts-mobile',
  FETCH_MAINTENANCE = 'fetch-maintenance',
  FETCH_MESSAGES = 'fetch-messages',
  FETCH_MESSAGES_MOBILE = 'fetch-messages-mobile',
  FETCH_MESSAGES_TMP = 'fetch-messages-tmp',
  FOOTER_CARD_CONTAINER_ZONE = 'footer-card-container-zone',
  FOOTER_CARD_CONTAINER_ZONE_DECK_01 = 'footer-card-container-zone-deck-01',
  FOOTER_CARD_CONTAINER_ZONE_DECK_02 = 'footer-card-container-zone-deck-02',
  IMAGE_0 = 'image-0',
  IMAGE_01_DECK_01 = 'image-01-deck-01',
  IMAGE_01_DECK_02 = 'image-01-deck-02',
  LAYOUT_CENTER = 'layout-center',
  LAYOUT_CENTER_MOBILE = 'layout-center-mobile',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  LAYOUT_MAIN = 'layout-main',
  LINK_DECK_0 = 'link-deck-0',
  LINK_DECK_1 = 'link-deck-1',
  LINK_DECK_2 = 'link-deck-2',
  MAIN_CARD_CONTAINER = 'main-card-container',
  MAIN_CARD_CONTAINER_1_DECK_01 = 'main-card-container-1-deck-01',
  MAIN_CARD_CONTAINER_1_DECK_02 = 'main-card-container-1-deck-02',
  MAIN_CARD_CONTAINER_HEADER = 'main-card-container-header',
  MAIN_CARD_CONTAINER_HEADER_01_DECK_01 = 'main-card-container-header-01-deck-01',
  MAIN_CARD_CONTAINER_HEADER_01_DECK_02 = 'main-card-container-header-01-deck-02',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_01 = 'mapper-01',
  MAPPER_2 = 'mapper-2',
  MAPPER_02 = 'mapper-02',
  MAPPER_2_DECK_01 = 'mapper-2-deck-01',
  MAPPER_2_DECK_02 = 'mapper-2-deck-02',
  MAPPER_11_DECK_01 = 'mapper-11-deck-01',
  MAPPER_11_DECK_02 = 'mapper-11-deck-02',
  MAPPER_CONTACTS = 'mapper-contacts',
  MAPPER_CONTACTS_MOBILE = 'mapper-contacts-mobile',
  MAPPER_MESSAGES = 'mapper-messages',
  MAPPER_MESSAGES_MOBILE = 'mapper-messages-mobile',
  MAPPER_MESSAGES_TMP = 'mapper-messages-tmp',
  MEDIA_QUERY = 'media-query',
  MEDIA_QUERY_MOBILE = 'media-query-mobile',
  MESSAGE_CARD = 'message-card',
  MESSAGE_CARD_MOBILE = 'message-card-mobile',
  MESSAGE_CARD_TMP = 'message-card-tmp',
  PAGINATOR_MAINTENANCE = 'paginator-maintenance',
  PANEL_0 = 'panel-0',
  PANEL_CONTACTS = 'panel-contacts',
  PANEL_CONTACTS_MOBILE = 'panel-contacts-mobile',
  PANEL_CONTENT = 'panel-content',
  PANEL_MAINTENANCE = 'panel-maintenance',
  PANEL_MESSAGES = 'panel-messages',
  PANEL_MESSAGES_MOBILE = 'panel-messages-mobile',
  PANEL_MESSAGES_TMP = 'panel-messages-tmp',
  PANEL_TOP = 'panel-top',
  TABLE_COLUMN_APPLICATION_NAME = 'table-column-application-name',
  TABLE_COLUMN_DATE = 'table-column-date',
  TABLE_COLUMN_REGION_NAME = 'table-column-region-name',
  TABLE_COLUMN_STATUS = 'table-column-status',
  TABLE_COLUMN_STATUS_MOBILE = 'table-column-status-mobile',
  TABLE_COLUMN_TYPE = 'table-column-type',
  TABLE_MAINTENANCE = 'table-maintenance',
  TEXT_CURRENT_MONTH = 'text-current-month',
  TEXT_TITLE_CONTACTS = 'text-title-contacts',
  TEXT_TITLE_CONTACTS_MOBILE = 'text-title-contacts-mobile',
  TEXT_TITLE_MAINTENANCE = 'text-title-maintenance',
  TEXT_TITLE_MESSAGES = 'text-title-messages',
  TEXT_TITLE_MESSAGES_MOBILE = 'text-title-messages-mobile',
  TEXT_TITLE_MESSAGES_TMP = 'text-title-messages-tmp',
  TEXT_ZONE_1 = 'text-zone-1',
  TEXT_ZONE_1_DECK_01 = 'text-zone-1-deck-01',
  TEXT_ZONE_1_DECK_02 = 'text-zone-1-deck-02',
  TEXT_ZONE_2 = 'text-zone-2',
  TEXT_ZONE_2_DECK_01 = 'text-zone-2-deck-01',
  TEXT_ZONE_2_DECK_02 = 'text-zone-2-deck-02',
}
export { DashboardAliases };
